import { aiProxyClient } from "@/services/aiProxyClient";
import { creditsService } from "@/services/creditsService";
import { queryClient } from "@/lib/queryClient";

let modelsCache: Awaited<ReturnType<typeof aiProxyClient.getModels>> | null = null;
let modelsCacheAt = 0;
const MODELS_CACHE_MS = 10 * 60_000;

async function getModelPricing(modelId: string) {
  const now = Date.now();
  if (!modelsCache || now - modelsCacheAt > MODELS_CACHE_MS) {
    modelsCache = await aiProxyClient.getModels();
    modelsCacheAt = now;
  }
  return modelsCache.find((m) => m.id === modelId)?.pricing;
}

export type FormatCreditResult = {
  creditsDeducted: number;
  hadEnoughBalance: boolean;
};

export async function deductCreditsForFormatResponse(
  model: string,
  usage?: { prompt_tokens?: number; completion_tokens?: number } | null
): Promise<FormatCreditResult | null> {
  if (!usage?.prompt_tokens && !usage?.completion_tokens) {
    return null;
  }

  const pricing = await getModelPricing(model);
  if (!pricing?.prompt && !pricing?.completion) {
    return null;
  }

  const result = await creditsService.deductCreditsForAIUsage({
    promptTokens: usage.prompt_tokens ?? 0,
    completionTokens: usage.completion_tokens ?? 0,
    promptPrice: pricing.prompt || "0",
    completionPrice: pricing.completion || "0",
    model,
    profitMultiplier: 3,
  });

  queryClient.invalidateQueries({ queryKey: ["/api/credits"] });
  queryClient.invalidateQueries({ queryKey: ["credits-overview"] });
  queryClient.invalidateQueries({ queryKey: ["billing-subscription"] });

  return {
    creditsDeducted: result.creditsDeducted,
    hadEnoughBalance: result.hadEnoughBalance,
  };
}
